import React from "react"
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap"

export default function FormControlInlineInput({ controlId, validationState, label, placeholder, value,
  onChange, helpText, className, disabled, type, min, max }) {

  return (
    <FormGroup controlId={ controlId } validationState={ validationState }>

      <Col componentClass={ ControlLabel } sm={4}>
        { label }
      </Col>

      <Col sm={8}>
        <FormControl type={ type || 'text' } placeholder={ placeholder }
          value={ value } className={ className }
          onChange={e => onChange(e.target.value)} id={ controlId }
          disabled={ disabled }
          min={ min }
          max={ max }
        />
        <FormControl.Feedback />
        <HelpBlock>{ helpText }</HelpBlock>
      </Col>
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/FormControl.Inline.Input.js